import { isIos, isAndroid } from "@tvg/sh-utils/mobileUtils";
import { ENV_KEYS } from "./constants";

export const getXsellKeys = () => {
  if (isIos()) return ENV_KEYS.sbk.ios;
  if (isAndroid()) return ENV_KEYS.sbk.android;

  return ENV_KEYS.sbk.web;
};
